var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageChartUp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00106 12H4.12606C3.52606 12 3.03906 12.487 3.03906 13.087V20.163C3.03906 20.763 3.52606 21.25 4.12606 21.25H5.99906C6.59906 21.25 7.08606 20.763 7.08606 20.163V13.087C7.08606 12.487 6.59906 12 5.99906 12M12.9381 7.375H11.0651C10.4651 7.375 9.97806 7.862 9.97806 8.462V20.163C9.97806 20.763 10.4641 21.25 11.0641 21.25H12.9381C13.5381 21.25 14.0251 20.763 14.0251 20.163V8.462C14.0251 7.862 13.5381 7.375 12.9381 7.375ZM19.8751 2.75H18.0021C17.4021 2.75 16.9151 3.237 16.9151 3.837V20.163C16.9151 20.763 17.4021 21.25 18.0021 21.25H19.8751C20.4751 21.25 20.9621 20.763 20.9621 20.163V3.837C20.9621 3.237 20.4751 2.75 19.8751 2.75Z",
    stroke: "#027A48",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5L11.5296 1.99353L14.0582 3.38616L14 0.5ZM3 6.19879L2.95675 6.44502C5.12842 6.82647 10.1069 6.91111 13.1194 2.61407L12.9147 2.47056L12.71 2.32705C9.86868 6.37997 5.15365 6.32325 3.04325 5.95255L3 6.19879Z",
    fill: "#027A48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageChartUp1);
export default __webpack_public_path__ + "static/media/mage_chart-up (1).f3cb25a05a5ec82240621e0533e4d54d.svg";
export { ForwardRef as ReactComponent };